import React from 'react';
import { Link } from 'react-router-dom';

const PostCard = ({ post }) => {
    return (
        <div className="card">
            <h2 className="card-title">{post.title}</h2>
            <p className="card-excerpt">{post.content.substring(0, 100)}...</p>
            <Link to={`/post/${post.id}`} className="read-more">Read More →</Link>
        </div>
    );
};

export default PostCard;
